import { useMutation } from '@tanstack/react-query';

import { createWishlistParamValue, useQueryInvalidation } from '@pkg/hooks';

import { type UseAddToWishlistParam } from '@app/client/common/structs/wishlists/wishlists';
import { Wishlists } from '@app/client/resources';
import { WISHLIST_SUMMARY_CACHE } from '@app/client/resources/fantasy';

type UpdateFantasyWishlistProps = {
    invalidateOnSuccess?: boolean;
};

function useDeleteFromLineup(props?: UpdateFantasyWishlistProps) {
    const invalidateQueries = useQueryInvalidation(WISHLIST_SUMMARY_CACHE);
    return useMutation({
        mutationFn: ({ wishlistId, competitionId, ...args }: UseAddToWishlistParam) => {
            const value = createWishlistParamValue({ ...args });
            if (competitionId) {
                value['competitionId'] = competitionId;
            }
            return Wishlists.callDeleteFromUserLineup({ wishlistId, value });
        },
        onSuccess: () => {
            if (props?.invalidateOnSuccess) {
                // Timeout prevents invalidating queries before BE processes it
                setTimeout(invalidateQueries, 1000);
            }
        },
    });
}

export { useDeleteFromLineup };
